export default __webpack_public_path__ + "fonts/poppins-latin-300-normal.39576fe9df8a22cc1bcc.woff2";